import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const RestaurantInfoManager = ({ onMessage }) => {
  const [info, setInfo, refetch] = useAdminData('restaurant-info', {});
  const [saving, setSaving] = useState(false);

  const fields = [
    ['name', 'Restaurant Name'], ['tagline', 'Tagline'],
    ['address', 'Address', 'md:col-span-2'],
    ['phone', 'Phone'], ['email', 'Email'],
    ['hours_label', 'Hours Day Range Label (e.g. Wednesday - Sunday)'], ['hours_weekdays', 'Hours Time (e.g. 5:00 PM - 10:30 PM)'],
    ['hours_closed_note', 'Closed Note (e.g. Closed Monday & Tuesday)', 'md:col-span-2'],
    ['hours_weekends', 'Weekend Hours (legacy / unused)'],
    ['instagram', 'Instagram URL'], ['facebook', 'Facebook URL'], ['tiktok', 'TikTok URL'],
  ];

  const save = async () => {
    setSaving(true);
    try { await apiCall('PUT', 'restaurant-info', info); onMessage('success', 'Saved'); refetch(); }
    catch (e) { onMessage('error', e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold mb-6">Restaurant Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map(([key, label, cls]) => (
          <div key={key} className={cls || ''}>
            <label className="block text-sm font-medium mb-2">{label}</label>
            <input type="text" value={info[key] || ''} onChange={(e) => setInfo({ ...info, [key]: e.target.value })} className="w-full border rounded-lg px-4 py-2" />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} className="mt-6 bg-[#C9A86C] text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50">
        <Save size={18} /> {saving ? 'Saving…' : 'Save Changes'}
      </button>
    </div>
  );
};

export default RestaurantInfoManager;
